<div class="mail-template">
  <div class="d-flex">
    <div class="p-inputgroup">
      <span class="mail-text" *ngIf="formGroup">{{ subjectText }}</span>
      <p-button
        type="button"
        pRipple
        icon="pi pi-pencil"
        styleClass="p-button-warn"
        [disabled]="disableField"
        class="icon-color icon-edit mail-edit"
        title="Editor"
        (onClick)="openMailTemplate()"
        [ngClass]="{ 'icon-loading': !iconLoaded }"
      />
    </div>
  </div>
</div>

<p-dialog
  header="{{ 'MAIL_TEMPLATE' | translate }}"
  [(visible)]="showMailTemplate"
  [style]="{ width: '60vw', maxHeight: '90vh' }"
  [contentStyle]="{ overflow: 'auto' }"
  styleClass="mail-template-modal"
  [modal]="true"
  appendTo="body"
  [draggable]="false"
  [baseZIndex]="9999"
  (onHide)="closeDialog()"
>
  <p-message *ngIf="warnFlag" severity="warn">
    <p class="mb-0" [innerHtml]="warning"></p>
  </p-message>
  <p-message *ngIf="errorFlag" severity="error">
    <p class="mb-0" [innerHtml]="message"></p>
  </p-message>
  <form [formGroup]="formGroup">
    <div class="form-group row mb-2" *ngIf="dataFrom">
      <label for="toRecipients" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required">{{
        'TO' | translate
      }}</label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center">
        <input
          id="toRecipients"
          name="toRecipients"
          type="checkbox"
          style="height: 12px !important; width: 15px; margin-right: 15px"
          disabled
          checked
        />
        <label for="toRecipients" class="mt-0 mb-0">
          <span *ngIf="dataFrom === 'import'">Person who initiated Import</span>
          <span *ngIf="dataFrom === 'export'">Person who initiated Export</span>
        </label>
      </div>
    </div>
    <div class="form-group row mb-2" *ngIf="dataFrom">
      <label
        for="additionalRecipients"
        class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 pr-0 col-form-label d-flex align-items-center justify-content-between"
        >Additional Recipients
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          pTooltip="User can choose roles for Additional Recipients and also allows to enter valid Email. To save the email, user has to type valid and click enter."
        ></i>
      </label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <ng-select
          id="additionalRecipients"
          formControlName="to"
          [addTag]="addCustomUser"
          [multiple]="true"
          (change)="onAddRecChange($event)"
        >
          <ng-option *ngFor="let option of options" [value]="option"> {{ option.actName }} </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="form-group row mb-2" *ngIf="!dataFrom">
      <label
        for="toRecipientsNoDataFrom"
        class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required pr-0"
        >{{ 'TO' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          pTooltip="User can choose roles for Additional Recipients and also allows to enter valid Email. To save the email, user has to type valid and click enter."
        ></i>
      </label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <ng-select
          id="toRecipientsNoDataFrom"
          formControlName="to"
          [addTag]="addCustomUser"
          [multiple]="true"
          (change)="onAddRecChange($event)"
        >
          <ng-option *ngFor="let option of options" [value]="option"> {{ option.actName }} </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="form-group row mb-2">
      <label
        for="ccRecipients"
        class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label pr-0 d-flex align-items-center justify-content-between"
        >{{ 'CC' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          pTooltip="User can choose roles for CC and also allows to enter valid Email. To save the email, user has to type valid and click enter."
        ></i
      ></label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <ng-select
          id="ccRecipients"
          formControlName="cc"
          [addTag]="addCustomUser"
          [multiple]="true"
          (change)="onCChange($event)"
        >
          <ng-option *ngFor="let option of options" [value]="option">{{ option.actName }} </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="form-group row mb-2">
      <label for="subject" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required">{{
        'SUBJECT' | translate
      }}</label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <input formControlName="subject" id="subject" type="text" class="form-control" [disabled]="disableField" />
      </div>
    </div>
    <div class="form-group text-editor row">
      <label for="editor" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label">{{
        'DESCRIPTION' | translate
      }}</label>
      <!-- <textarea formControlName="description"   id="div_editor3"></textarea> -->
      <!-- <quill-editor [styles]="{height: '200px'}"></quill-editor> -->
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8 mail-modal">
        <div class="editor-wrapper">
          <div class="col-12" #editorDiv (input)="onDescriptionInput($event)" id="editor"></div>
        </div>
      </div>
      <p-button class="set-as-variable" label="Set as Variable" (onClick)="getSelectionHtml()" />
    </div>
  </form>
  <div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoading">
    <div class="spinner-container">
      <p-progress-spinner></p-progress-spinner>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="submit" (click)="onSave()" class="btn btn-primary">{{ 'SAVE' | translate }}</button>
  </ng-template>
</p-dialog>
